import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { HiMenuAlt3, HiX } from 'react-icons/hi';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const handleNav = () => setNav(!nav);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', to: 'home' },
    { name: 'About', to: 'about', offset: -70 },
    { name: 'Skills', to: 'skills', offset: -70 },
    { name: 'Projects', to: 'projects', offset: -70 },
    { name: 'Experience', to: 'experience', offset: -70 },
    { name: 'Contact', to: 'contact', offset: -70 },
  ];

  return (
    <nav className={`fixed w-full h-20 z-[100] transition-all duration-300 ${scrolled ? 'glass h-16 shadow-lg border-b border-white/5' : 'bg-transparent'}`}>
      <div className="flex justify-between items-center w-full h-full px-6 md:px-12 lg:px-24">
        {/* Logo */}
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          className="cursor-pointer"
        >
          <h1 className="text-2xl font-display font-bold tracking-tighter text-white group">
            <span className="text-accent-primary">A</span>
            <span>G</span>
            <span className="text-accent-primary group-hover:animate-pulse">.</span>
          </h1>
        </motion.div>

        {/* Desktop Menu */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link, index) => (
            <motion.li 
              key={index}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <Link 
                to={link.to} 
                smooth={true} 
                duration={500} 
                offset={link.offset}
                className="nav-link cursor-pointer"
                activeClass="text-accent-primary after:!w-full"
                spy={true}
              >
                <span className="text-accent-primary text-xs mr-1">0{index + 1}.</span> {link.name}
              </Link>
            </motion.li>
          ))}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.7 }}
          >
            <Link to="contact" smooth={true} duration={500} offset={-70}>
              <button className="btn-primary py-2 px-6 ml-4 text-xs">Hire Me</button>
            </Link>
          </motion.div>
        </ul>

        {/* Hamburger */}
        <div onClick={handleNav} className="md:hidden z-10 cursor-pointer text-accent-primary text-3xl">
          {!nav ? <HiMenuAlt3 /> : <HiX />}
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence>
        {nav && (
          <motion.div 
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'tween', duration: 0.4 }}
            className="fixed top-0 right-0 w-[75%] h-screen glass z-[-1] flex flex-col justify-center items-center shadow-2xl"
          >
            <ul className="flex flex-col gap-10 items-center">
              {navLinks.map((link, index) => (
                <li key={index} className="text-2xl font-mono">
                  <Link 
                    onClick={handleNav} 
                    to={link.to} 
                    smooth={true} 
                    duration={500}
                    offset={link.offset}
                    className="flex flex-col items-center gap-2 group"
                  >
                    <span className="text-accent-primary text-sm">0{index + 1}.</span>
                    <span className="group-hover:text-accent-primary transition-colors">{link.name}</span>
                  </Link>
                </li>
              ))}
              <div className="mt-4">
               <Link onClick={handleNav} to="contact" smooth={true} duration={500} offset={-70}>
                  <button className="btn-primary">Hire Me</button>
                </Link>
              </div>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
